module.exports = __webpack_public_path__ + "images/avatar9.svg";